import React, { useEffect, useState } from "react";
import { supabase } from "../services/supabase";
import { useRole } from "../context/RoleContext";
import { FaPencilAlt, FaTimesCircle } from "react-icons/fa";

export default function DispatcherPage() {
  const { currentMode } = useRole();
  const isAdmin = currentMode === "admin";

  const [dispatchers, setDispatchers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editingDispatcher, setEditingDispatcher] = useState(null);
const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone: "",
    password: "",
  });

  const [creating, setCreating] = useState(false);

  // Charger répartiteurs
  const loadDispatchers = async () => {
    setLoading(true);

    const { data, error } = await supabase
      .from("profiles")
      .select("id, full_name, phone, email, created_at")
      .eq("role", "collaborateur")
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Erreur chargement dispatchers:", error);
    } else {
      setDispatchers(data);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadDispatchers();
  }, []);

  // Modifier un repartiteur
  const startEditDispatcher = (dispatcher) => {
  setEditingDispatcher(dispatcher);
  setForm({
    full_name: dispatcher.full_name || "",
    email: dispatcher.email || "",
    phone: dispatcher.phone || "",
    password: "", // jamais préremplir
  });
};

// Update dispatcher
const updateDispatcher = async () => {
  if (!form.full_name || !form.email) {
    alert("Nom et email requis.");
    return;
  }

  setSaving(true);

  // 1️⃣ Update infos profile
  const { error: profileError } = await supabase
    .from("profiles")
    .update({
      full_name: form.full_name,
      email: form.email,
      phone: form.phone,
    })
    .eq("id", editingDispatcher.id);

  if (profileError) {
    alert("Erreur lors de la mise à jour du profil");
    console.error(profileError);
    setSaving(false);
    return;
  }

  // 2️⃣ Reset password SI fourni
  if (form.password && form.password.length >= 8) {
    const confirmReset = window.confirm(
      "Confirmer le changement du mot de passe pour ce répartiteur ?"
    );

    if (!confirmReset) {
      setSaving(false);
      return;
    }

    const { error: pwdError } = await supabase.functions.invoke(
      "admin-reset-password",
      {
        body: {
          userId: editingDispatcher.id,
          newPassword: form.password,
        },
      }
    );

    if (pwdError) {
      alert("Erreur lors du changement de mot de passe");
      console.error(pwdError);
      setSaving(false);
      return;
    }
  }

  alert("Répartiteur mis à jour avec succès");

  setEditingDispatcher(null);
  setForm({ full_name: "", email: "", phone: "", password: "" });
  loadDispatchers();
  setSaving(false);
};


  // Créer un dispatcher
  const createDispatcher = async () => {
  if (!form.full_name || !form.email || !form.password) {
    alert("Tous les champs sont requis.");
    return;
  }

  setCreating(true);

  const session = (await supabase.auth.getSession()).data.session;

const res = await supabase.functions.invoke("create-dispatcher", {
  body: JSON.stringify({
    full_name: form.full_name,
    email: form.email,
    phone: form.phone,
    password: form.password,
  }),
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${session.access_token}`,
  },
});

console.log("FUNCTION RESPONSE:", res);

if (res.error) {
  alert(res.error.message || "Erreur création répartiteur");
  setCreating(false);
  return;
}

  alert("Répartiteur créé avec succès !");
  setForm({ full_name: "", email: "", phone: "", password: "" });
  loadDispatchers();
  setCreating(false);
};

// Supprimer un répartiteur
const deleteDispatcher = async (dispatcher) => {
  const ok = window.confirm(
    `Supprimer le répartiteur "${dispatcher.full_name}" ? Cette action est irréversible.`
  );

  if (!ok) return;

  const { data, error } = await supabase
    .from("profiles")
    .delete()
    .eq("id", dispatcher.id)
    .eq("role", "collaborateur")
    .select("id");

  console.log("DELETE RESULT:", { data, error, dispatcherId: dispatcher.id });

  if (error) {
    alert("Erreur lors de la suppression : " + error.message);
    console.error("DELETE ERROR:", error);
    return;
  }

  if (!data || data.length === 0) {
    alert("Aucun répartiteur n’a été supprimé. Contactez votre développeur.");
    return;
  }

  alert("Répartiteur supprimé");
  loadDispatchers();
};



  return (
    <div>
      <h2>Gestion des Répartiteurs</h2>

      {/* FORMULAIRE — seulement pour admin */}
      {isAdmin && (
        <div className="dispatcher-form">
          <h3>{editingDispatcher ? "Modifier un répartiteur" : "Créer un répartiteur"}</h3>


          <div className="form-row">
            <input
              type="text"
              placeholder="Nom complet"
              value={form.full_name}
              onChange={(e) => setForm({ ...form, full_name: e.target.value })}
            />

            <input
              type="email"
              placeholder="Email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />

            <input
              type="text"
              placeholder="Téléphone (optionnel)"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
            />

            {!editingDispatcher && (
              <input
                type="password"
                placeholder="Mot de passe"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            )}

            {editingDispatcher && (
              <input
                type="password"
                placeholder="Nouveau mot de passe (laisser vide si inchangé)"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            )}
          </div>

          <button
              className="btn-primary"
              onClick={editingDispatcher ? updateDispatcher : createDispatcher}
              disabled={creating || saving}
            >
              {editingDispatcher
                ? saving ? "Mise à jour..." : "Mettre à jour"
                : creating ? "Création..." : "Créer"}
            </button>

            {editingDispatcher && (
              <button
                className="btn-secondary"
                onClick={() => {
                  setEditingDispatcher(null);
                  setForm({ full_name: "", email: "", phone: "", password: "" });
                }}
              >
                Annuler
              </button>
            )}
        </div>
      )}

      <hr />

      {/* LISTE */}
      <h3>Liste des répartiteurs</h3>

      {loading ? (
        <p>Chargement…</p>
      ) : dispatchers.length === 0 ? (
        <p>Aucun répartiteur trouvé.</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Créé le</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {dispatchers.map((d) => (
              <tr key={d.id}>
                <td>{d.full_name}</td>
                <td>{d.email}</td>
                <td>{d.phone || "—"}</td>
                <td>{new Date(d.created_at).toLocaleString()}</td>
                <td>
                    {isAdmin && (
                      <div className="icone-course">
                        <button
                          className="btn-secondary"
                          title="Modifier"
                          onClick={() => startEditDispatcher(d)}
                        >
                          <FaPencilAlt />
                        </button>

                        <button
                          className="btn-danger"
                          title="Supprimer"
                          onClick={() => deleteDispatcher(d)}
                        >
                          <FaTimesCircle />
                        </button>
                      </div>
                    )}
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
